import React, { Component } from 'react';
import Table from '../../../../components/_table/Table/Table';
import Button from '../../../../components/Button';
import Panel from '../../../../components/outline/Panel';
import { TAG_CREATE_URL_PATH } from '../../../../constants/service/common/urlConstants';
import { comparePrePropsAndNextProps, reDirectPage } from '../../../../lib/common';
import { columns } from './columns';
import './TagList.scss';

class TagList extends Component {
  /**
   *  Component 의 변경되는 props 와 state 가 있을 경우에만,
   *  render 메소드를 호출할 수 있도록 함
   */
  shouldComponentUpdate = (nextProps) => {
    return comparePrePropsAndNextProps([[nextProps, this.props]]);
  };

  render() {
    const { tagList, initialOption, sortOption, pagination, getList, getRelatedTagList, getTagListExcelDownload } =
      this.props;

    return (
      <div className="tag-list">
        <Panel>
          <div className="panel-header">
            <div className="title">태그 리스트</div>
            <div className="btn-area">
              <Button text="엑셀 다운로드" onClick={() => getTagListExcelDownload()} />
              <Button
                color="primary"
                text="태그 생성하기"
                onClick={() => reDirectPage({ path: TAG_CREATE_URL_PATH })}
              />
            </div>
          </div>

          <div className="panel-body">
            <Table
              columns={(utils) =>
                columns({
                  ...utils,
                  getRelatedTagList,
                })
              }
              rowKey={(record) => record.id}
              initialOption={initialOption}
              sortOption={sortOption}
              pagination={pagination}
              list={tagList}
              size="small"
              scroll={{ x: true }}
              bordered={true}
              getList={getList}
            />
          </div>
        </Panel>
      </div>
    );
  }
}

export default TagList;
